'use strict';
//import $ from "jquery";
import * as SpriteSpin from "spritespin";

class ImageLoad {

    constructor() {
        this.url = 'https://report.tal-gr.com/storage/picture';
        this.noImage = '/assets/images/no-image.jpg';
        //this.lightbox = null;
    }

    loadImage(imgName) {

        var img = new Image();
        var itemImageContainer = document.getElementById('itemImageContainer');
        var itemImage = document.getElementById('itemImage');
        img.onload = () => {

            itemImage.src = img.src;
            //itemImageContainer.href = img.src;
        }
        img.onerror = () => {
            itemImage.src = this.noImage;
            //itemImageContainer.href = this.noImage;
        }

        img.src = this.url + imgName;

    }

    /**
     * 回転画像のロード.
     */
    loadSpinImage(imgPath, spin_images) {

        var targetSource = [];

        for (let idx in spin_images) {
            targetSource.push(this.url + imgPath + spin_images[idx]);
        }

        var $spritespin = $('.spritespin')

        $(".preloader-wrapper").addClass('active');

        $spritespin.spritespin({
            source: targetSource,
            sizeMode: 'fit',
            width: $spritespin.width(),
            height: 300,
            sense: -1,
            animate: false,
            onComplete: () => {
                $(".preloader-wrapper").removeClass('active');
                $('<i class="spinIcon medium material-icons">').text('3d_rotation').appendTo($('#imgContainerSpin'));
            }
        });

    }

    /**
     * HTMLプレビューのiframe表示.
     */
    loadHtmlFrame(imgPath) {

        let $iframe = $('#iframeSpin iframe')
        $iframe.attr('src', imgPath)
    }

}

export default ImageLoad;


